import { useState, useCallback } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { motion } from "../../AuthNew/shared/motionUtils";
import {
  ModalTitle,
  ModalSubtitle,
  slideInRight,
  SecondaryButton,
} from "../shared/onboardingStyles";
import { CommonFlex } from "../../../styledComponents/common";
import { clearLocalStorage } from "../../../utils/handleLogout";

const CreateMyOwnButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.main.authGray};
  font-size: 13px;
  cursor: pointer;
  padding: 8px;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.main.authTextSecondary};
    text-decoration: underline;
  }
`;

const SignOutButton = styled(CreateMyOwnButton)``;

const JoinRequestCardContainer = styled(motion.div)`
  background: ${({ theme }) => theme.colors.main.white};
  border: 1px solid ${({ theme }) => theme.colors.border.secondaryLight};
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 30px;
`;

const OrganizationIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: ${({ theme, color }) => color || theme.colors.main.authBlueLight};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-size: 24px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.main.authBlue};
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  margin-top: 24px;
`;

const Step1JoinRequest = ({
  pendingJoinRequest,
  userInfo,
  loginProfileCreatedReset,
  onCreateOrganization,
}) => {
  const history = useHistory();

  const handleCreateOrganization = useCallback(() => {
    // User chooses to create organization
    if (onCreateOrganization) {
      onCreateOrganization();
    }
  }, [onCreateOrganization]);

  const handleSignOut = useCallback(() => {
    clearLocalStorage();
    history.push("/auth/login");
    if (loginProfileCreatedReset) {
      loginProfileCreatedReset();
    }
  }, [history, loginProfileCreatedReset]);

  const organizationName =
    pendingJoinRequest?.organization_name ||
    pendingJoinRequest?.organization?.name ||
    "Organization";

  return (
    <motion.div
      variants={slideInRight}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <ModalTitle>
        Hi {userInfo?.first_name}, You have a pending join request!
      </ModalTitle>
      <ModalSubtitle>
        Your request to join is pending approval from the organization owner
      </ModalSubtitle>

      <JoinRequestCardContainer
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <OrganizationIcon>
          {organizationName.charAt(0).toUpperCase()}
        </OrganizationIcon>

        <ModalTitle
          style={{
            fontSize: "20px",
            fontWeight: "600",
            margin: "0 0 8px 0",
          }}
        >
          {organizationName}
        </ModalTitle>

        <ModalSubtitle>Your join request is pending approval</ModalSubtitle>
      </JoinRequestCardContainer>

      <CommonFlex
        justifyContent="center"
        margin="24px 0 0 0"
        gap="0"
        direction="column"
      >
        {/* <CreateMyOwnButton onClick={handleCreateOrganization}>
          Create My Own
        </CreateMyOwnButton> */}
        <SignOutButton onClick={handleSignOut}>Sign out</SignOutButton>
      </CommonFlex>
    </motion.div>
  );
};

export default Step1JoinRequest;
